import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, setPageNumberForDocument, setPageSizeForDocument } from "../store";

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const usePagination = () => {
  const dispatch = useDispatch();
  const pageNumberFromStore = useSelector((state: RootState) => state.document.pageNumber);
  const pageSizeFromStore = useSelector((state: RootState) => state.document.pageSize);

  const [page, setPage] = useState(parseInt(pageNumberFromStore) || 1);
  const [pageSize, setPageSize] = useState(pageSizeFromStore || PAGE_SIZE_OPTIONS[1]);

  useEffect(() => {
    setPage(parseInt(pageNumberFromStore) || 1);
  }, [pageNumberFromStore]);

  useEffect(() => {
    setPageSize(pageSizeFromStore || PAGE_SIZE_OPTIONS[1]);
  }, [pageSizeFromStore]);

  const onChange = useCallback(
    (updatedPage: number, updatedPageSize: number) => {
      if (updatedPage !== page) {
        setPage(updatedPage);
        dispatch(setPageNumberForDocument(updatedPage.toString()));
      }

      if (updatedPageSize !== pageSize) {
        setPageSize(updatedPageSize);
        dispatch(setPageSizeForDocument(updatedPageSize));
        setPage(1);
        dispatch(setPageNumberForDocument("1"));
      }
    },
    [page, pageSize, dispatch]
  );

  return {
    page,
    pageSize,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    onPaginationChange: onChange,
  };
};